import React from 'react';

import {
	IconButton,
	Link,
	Paper,
	Tooltip,
	TooltipProps,
	styled,
	tooltipClasses,
} from '@mui/material';

export const StyledReportInfoBlockWrap = styled(Paper)(() => ({
	display: 'flex',
	alignItems: 'center',
	flexDirection: 'column',
	height: 'fit-content',
	width: '100%',
	overflow: 'hidden',
	borderRadius: '16px',
	padding: '8px',
	margin: 0,
}));

export const StyledReportInfoBlockHeaderWrap = styled('div')(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	background: theme.palette.primary.main,
	borderRadius: '10px',
	boxShadow: '0px 0px 30px 0px #827D8326',
	width: '100%',
	maxWidth: '100%',
	gap: '12px',
	color: '#FFF',
	WebkitTapHighlightColor: 'transparent',
	padding: '14px 8px 14px 8px',
	justifyContent: 'space-between',
	cursor: 'pointer',
}));

export const StyledReportInfoBlockHeaderCollapseButton = styled(IconButton)(() => ({
	width: '24px',
	height: '24px',
	padding: '0px',
	color: '#FFF',
	display: 'block',
}));

export const StyledReportInfoBlockTooltip = styled(({ className, ...props }: TooltipProps) => (
	<Tooltip {...props} classes={{ popper: className }} />
))(() => ({
	[`& .${tooltipClasses.tooltip}`]: {
		background: '#FFFFFFB2',
		boxShadow: '0px 0px 30px 0px #827D8326',
		padding: '4px 8px 4px 8px',
		fontSize: '12px',
		lineHeight: '17px',
		color: '#474747',
		textWrap: 'balance',
		maxWidth: '200px',
	},

	[`& .${tooltipClasses.arrow}`]: {
		color: '#FFFFFFB2',
	},
}));

export const StyledReportInfoBlockHeaderTitleWrap = styled('div')(() => ({
	display: 'flex',
	alignItems: 'center',
	gap: '8px',
	minWidth: 0,
	flexDirection: 'row-reverse',
}));

export const StyledReportInfoBlockHeaderLink = styled(Link)({
	display: 'flex',
	textDecoration: 'none',
	color: '#FFF',
});
